/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext, useRef } from 'react';
import { useMediaQuery, Avatar, makeStyles, FormControl, InputLabel, Select, MenuItem, Button, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { List, Datagrid, TextField, FunctionField, SimpleList, usePermissions, useRefresh } from 'react-admin';
import moment from "moment";
import { customTheme } from "./customTheme";
import { vehicleSvgs, hideName, hideVehicleNumber, hideMobileNumber as hideMobileMask,  fastagIssuers } from "./sharedData";
import config from "./config.json";
// import DisplayColumnsButton from './components/DisplayColumnsButton';
import queryString from 'query-string';
import CustomExportButton from './components/CustomExportButton';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import ScrollableTable from './components/ScrollableTable';
import CustomFilter from './components/CustomFilter';
import CustomSearch from './components/CustomSearch';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import PrivacyPasswordAuthentication from './components/CustomPrivacyPasswordAuth';
import ImageGalleryDialogV2 from './components/ImageGalleryDialogV2';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
// import AutorenewIcon from '@material-ui/icons/Autorenew';
import { io } from 'socket.io-client'
import { ContextProvider } from './globalContextProvider';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import { generateReport } from './utils/generateReports';
import GetAppIcon from "@material-ui/icons/GetApp";
import ShowTimePeriod from './components/ShowTimePeriod';
import PermitSummaryCard from './components/PermitSummaryCard'
import { useHistory } from "react-router-dom";
import ParkSmartTag from './images/parksmartTag.png'

//const socket = io(`${config.HOST_NAME}`)
const socket = io(`${config.HOST_NAME}`, { transports: ['websocket', 'polling', 'flashsocket'] })

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
});

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
        </div>
        :
        null
);
const renderAction = action => {
    var color;
    switch (action) {
        case "ENTRY": color = customTheme.palette.primary.main; break;
        case "RAMP ENTRY": color = customTheme.palette.primary.main; break;
        case "EXIT": color = customTheme.palette.error.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color }}>{action}</div>;
}

const renderActionForMob = action => {
    var color;
    switch (action) {
        case "ENTRY": color = customTheme.palette.primary.main; break;
        case "RAMP ENTRY": color = customTheme.palette.primary.main; break;
        case "EXIT": color = customTheme.palette.error.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color, display: "inline" }}>{action}</div>;
}

const getSearchState = (searchObj) => {
    let newSearch = []
    for (let i in searchObj) {
        if (searchObj[i].showSearch) {
            newSearch.push(searchObj[i].name)
        }
    }
    return newSearch
}

const CATEGORY = "PERMIT LOGS SECTION"
const getFastagIssuerId = (tagId) => {
    let tagIdBin = "";
    for (let i = 0; i < tagId.length; i++) {
        tagIdBin += (parseInt(tagId[i], 16).toString(2)).padStart(4, "0");
    }
    const issuerId = parseInt(tagIdBin.substr(43, 20), 2).toString();
    return issuerId;
};

const renderTagImageDataGrid = record => {
    if (!record) return '-'
    if (record && (record['rfid'] == null || record['rfid'] === '')) return '-'

    let fix = record["rfid"] ? record["rfid"] : ""
    const issuerId = getFastagIssuerId(fix);
    const issuer = fastagIssuers[issuerId] ? fastagIssuers[issuerId] : null;
    if (typeof issuer === "string") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img className='tableDataImg' src={`/images/${issuer.replace(/\s/g, "")}.png`} alt={issuer} />
        </div>
    }
    else if (typeof record.tag_id === "string" && record.tag_id !== "") {
        return <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img className='tableDataImg' src={ParkSmartTag} alt="ParkSmart" style={{ display: "block", margin: "auto" }} />
        </div>
    }
    else
        return "-"
};

const ENTRYEXITMODES = {
    "ANPR": { label: "ANPR" , style: {color: "#E99100", backgroundColor: "#E9910019"}  },
    "FASTag": { label:"FASTag", style: {color: "#5E8DD3", backgroundColor: "#5E8DD319"}  },
    "anpr": { label: "ANPR" , style: {color: "#E99100", backgroundColor: "#E9910019"}  },
    "rfid": { label:"FASTag", style: {color: "#5E8DD3", backgroundColor: "#5E8DD319"}  },
    "MIXED": { label:"MIXED" , style: {color: "#109CF1", backgroundColor: "#109CF119" } },
    "pos": { label: "POS" , style: {color: "#E99100", backgroundColor: "#E9910019"}  },
    "POS": { label: "POS" , style: {color: "#E99100", backgroundColor: "#E9910019"}  },
    "PSTag": { label: "PSTag" , style: {color: "#18CC69", backgroundColor: "#18CC6919"}  },
    "-": { label: "-", style : {color: "#707683", backgroundColor: "#EBEFF2"} }
};

export const RfidLogsListV2 = props => {
    const eventTracker = UseAnalyticsEvent()
    const { showLiveFeed, setShowLiveFeed, setVisibleSnackBar, sectionLoader } = useContext(ContextProvider);
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const navigate = useHistory()
    const location = useLocation()
    const refresh = useRefresh();
    const listDataRef = useRef();
    let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg";

    const { permissions } = usePermissions();
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const abortLogsSummaryRequest = useRef(null);
    const [showRfidColumn] = useState(sessionStorage.getItem("show_rfid_column") === "1");
    const [showTagColumn] = useState(sessionStorage.getItem("show_tag_column") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [hideMobileNumber] = useState(sessionStorage.getItem("hide_mobile_number") === "1");
    //const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
    const RFID_COLUMNS = {
        "Parking Name": false, "RFID": false,
        "Image": true, "Vehicle Number": true,
        "Type": true, "Model": true,
        "Name": true, "Tag": true,
        "Mobile": true, "Tag ID": true,
        "Action": true, "Entry Gate": true,
        "Exit Gate": true, "Time": true,
        "Company": true, "User Type": true,
        "Tower": true, "Flat Number": true,
        "Parking Slots": true, "Device ID": true,
        "Gate" : true, "Recent Document Validity": true,
        "Other Images": true, "Raw Image": true,
        "Confidence": true, "Bounding Box": true,
    };
    if(permissions !== "admin" && !showRfidColumn) delete RFID_COLUMNS["RFID"]
    if(permissions !== "admin" && !showTagColumn) delete RFID_COLUMNS["Tag ID"]
    const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("rfidLogsColumns") ? JSON.parse(localStorage.getItem("rfidLogsColumns")) : RFID_COLUMNS);
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [summary, setSummary] = React.useState({ data: null, loading: true });

    const [dialogVisible, setDialogVisible] = React.useState(false);
    // const [showLiveFeed, setShowLiveFeed] = React.useState(false);
    const [parkingCount, setParkingCount] = React.useState(null);

    
    const [privacyFeatureAccess, setPrivacyFeatureAccess] = useState(sessionStorage.getItem('privacy_feature_access') === "1")

    const [showCompany] = useState(sessionStorage.getItem("show_rfid_company") === "1");
    const [showCompanyColumn] = useState(sessionStorage.getItem("show_company_column") === "1");
    const [showFlatDetails] = useState(sessionStorage.getItem("show_flat_details") === "1");
    const [showAnprRawImage] = useState(sessionStorage.getItem("show_anpr_raw_image") === "1");
    const [showSurveillanceImages] = useState(sessionStorage.getItem("show_surveillance_images") === "1");
    const [highLightRecordIds, setHighLightRecordIds] = useState({})
    const [showTiles, setShowTiles] = useState(true)
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    // CustomeFilter & CustomSearch States
    let searchStateObject = [
        { name: "Vehicle Number", showSearch: true },
        { name: "Name", showSearch: true },
        { name: "Mobile", showSearch: true },
        { name: "RFID", showSearch: showRfidColumn },
        { name: "Device ID", showSearch: true },
        { name: "Tag ID", showSearch: true },
        { name: "Tower Name", showSearch: (showFlatDetails || permissions === "admin") },
        { name: "Flat Number", showSearch: (showFlatDetails || permissions === "admin") },
        { name: "Gate ID", showSearch: true },
    ]
    let searchTypeState = getSearchState(searchStateObject)
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const [accessKey, setAccessKey] = useState(null);
    const handleAccessKey = (data) => {
        // Update state with the fetched data
        setAccessKey(data);
    };
    let filterTypesInitState = [
        {
            resourcePath: "rfidOrganization",
            filterType: "Organization",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "organization",
            showFilter: showCompany
        },
        {
            filterType: "Vehicle Type",
            dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Action",
            dataList: [{ name: "ENTRY", id: 2 }, { name: "EXIT", id: 3 }, { name: "RAMP ENTRY", id: 4, show: sessionStorage.getItem("show_ramp_entry") === "1" }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
			resourcePath: "parkingDevices",
			filterType: "Gates",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON"
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox",
			showSearchBar: true
		},
        {
            filterType: "Log By",
            dataList: [{ name: "ANPR", id: 1 }, { name: "FASTag", id: 2 }, {name: "ParkSmart Tag", id: 3}],
            listType: "Static",
            caseType: "Static",
            showFilter: sessionStorage.getItem("show_anpr_options") === "1"
        },
        {
            filterType: "Display Columns",
            dataList: { "Parking Name": false, "RFID": false },
            listType: "CheckboxStatic",
            caseType: "CheckboxTypeStatic",
            showFilter: true,
            filterFormat: "Checkbox"
        },
        {
            filterType: "Other",
            dataList: [{ name: "Live Feed", id: 1 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },

    ]

    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const timeFormatMobile = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const timeFormat = (time) => {
        let addSeconds = showTimeTillSeconds ? ":ss" : "";
        let format = use24HourFormat ? `HH:mm${addSeconds}`: `hh:mm${addSeconds} A`
        return <div>
            <div className='logsTableDataColor1 fontWeightBold'>{moment(time).format(format)}</div>
            <div className='logsTableDataColor2 fontWeightMedium'>{moment(time).format("DD/MM/YYYY")}</div>
        </div>
    }

    const onParkingChange = (parking) => {
        if (parking == null) {
            setShowLiveFeed(false)
            eventTracker(CATEGORY, "LIVE FEED DISABLE")
            socket.close()
        }
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const getExportFile = (fileType) => {
        const { current: { total, currentSort, filterValues } } = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/v2/rfidLogs?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                const timeFormat = "Do MMM YYYY (h:mm A)";
                let startTime = filter.start_time;
                if (startTime)
                    startTime = moment(startTime).format(timeFormat);
                else
                    startTime = moment().startOf("day").format(timeFormat);
                let endTime = filter.end_time;
                if (endTime)
                    endTime = moment(endTime).format(timeFormat);
                else
                    endTime = moment().endOf("day").format(timeFormat);

                tempLinkElement.setAttribute('download', `${startTime} - ${endTime} - ${currentParking && currentParking.name ? currentParking.name : "Permit Logs"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    const getPDF = () => {
        getExportFile("pdf");
    };

    const postRowStyle = (record, index) => {
        return {
            animation: record && record.id === highLightRecordIds[record.id] ? "blinkingBackground 2s infinite" : ""
        };
    }

    const fomattingFilter = (filterList) => {
		const result = {};
		if (filterList) {
			for (const obj of filterList) {
				const { filterType, value, id } = obj;
                if(filterType === 'Log By' && value && id) {
                    result[filterType.replaceAll(" ", "_").toLowerCase()] = { value: value === 'ParkSmart Tag' ? 'PARKSMART-TAG' : value === 'FASTag' ? 'NON-ANPR' : value, id };
                }
				else if (value && id) result[filterType.replaceAll(" ", "_").toLowerCase()] = { value, id };
			}
		}
		return result;
	}

    const reportParams = {
        access_key_ids: currentParking.allZones ? zoneIds : currentParking.id ? [currentParking.id] : undefined,
        report_name: "PERMIT_LOGS",
        report_format: "xlsx",
        start_time: moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"),
        end_time: moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"),
        filters: filterListValue ? fomattingFilter(filterListValue) : undefined,
    };

    const renderDocumentExpiry = (record) => {
        const puccExpiry = record.pucc_validity ? record.pucc_validity : null;
        const insuranceExpiry = record.insurance_validity ? record.insurance_validity : null;
    
        if (!record || (!puccExpiry && !insuranceExpiry)) return <div>-</div>;

        const puccExpiryMoment = moment(puccExpiry);
        const insuranceExpiryMoment = moment(insuranceExpiry);
        
        const getExpiryStatus = (dateMoment) => {
            const currentDate = moment();
            const differenceInDays = Math.abs(currentDate.diff(dateMoment, 'days'));
        
            let details = {}
            if (differenceInDays >= 30 && dateMoment.isAfter(currentDate)) details = { status: "Valid", color: "#18CC69", backgroundColor: "#18CC6919" }
            else if (differenceInDays < 30 && differenceInDays > 7 && dateMoment.isAfter(currentDate)) details = { status: "Expiring Soon", color: "#334D6E", backgroundColor: "#334D6E19" }
            else if (differenceInDays < 7 && differenceInDays > 0 && dateMoment.isAfter(currentDate)) details = { status: "About to expired", color: "#E5CE00", backgroundColor: "#E5CE0019" }
            else details = { status: "Expired", color: "#F7685B", backgroundColor: "#F7685B19" }

            return <div style={{ fontFamily: "Poppins-Bold", color: details["color"], backgroundColor: details["backgroundColor"], fontSize: 10, padding: "1px 0px" }}>
                <div>{details["status"]}</div>
            </div>
        }

        if (puccExpiryMoment.isValid() && insuranceExpiryMoment.isValid()) {
            if(puccExpiryMoment.isSameOrBefore(moment(), 'day') && insuranceExpiryMoment.isSameOrBefore(moment(), 'day')){
                return (
                    <div style={{textAlign:"center", fontSize: 12}}>
                        <div>Puc & Insurance</div>
                        {getExpiryStatus(puccExpiryMoment)}
                    </div>
                );
            }
            else {
                const closestExpiry = puccExpiryMoment.isBefore(insuranceExpiryMoment) ? puccExpiryMoment : insuranceExpiryMoment;
                const expiryType = closestExpiry.isSame(puccExpiryMoment) ? "Puc" : "Insurance";
                return (
                    <div style={{textAlign:"center", fontSize: 12}}>
                        <div>{expiryType}: {closestExpiry.format("DD/MM/YYYY")}</div>
                       {getExpiryStatus(closestExpiry)}
                    </div>
                );
            }
        } else if (puccExpiryMoment.isValid()) {
                return (
                    <div style={{textAlign:"center", fontSize: 12}}>
                        <div style={{fontSize: 10}}>Puc: {puccExpiryMoment.format("DD/MM/YYYY")}</div>
                        {getExpiryStatus(puccExpiryMoment)}
                    </div>
                );
        } else if (insuranceExpiryMoment.isValid()) {
                return (
                    <div style={{textAlign:"center", fontSize: 12}}>
                        <div>Insurance: {insuranceExpiryMoment.format("DD/MM/YYYY")}</div>
                        {getExpiryStatus(insuranceExpiryMoment)}
                    </div>
                );
        } else return <div>-</div>;
    };
    
    const reportHandler = async () => {
       const reportStatus = await generateReport(reportParams)
       if(reportStatus.success) navigate.push("/reports")
       else notify(reportStatus.message, "warning")
    }

    useEffect(() => {
        eventTracker(CATEGORY, " PERMIT LOGS LIST")
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getParkingSummary = (realTimeData) => {
        if (abortLogsSummaryRequest.current) abortLogsSummaryRequest.current.abort()
            abortLogsSummaryRequest.current = new AbortController();
        if (!realTimeData) {
            setSummary({ ...summary, data: null, loading: true });
        }
        fetch(`${config.HOST_NAME}/crm/rfidLogSummary?access_key_id=${currentParking.id}&parking_info_id=${currentParking.allZones ? currentParking.parking_info_id : undefined}&start_time=${startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&end_time=${endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""}&user_id=${sessionStorage.getItem("user_id")}&vehicle_type=${settingFilterFormat.vehicle_type}&action=${settingFilterFormat.action}&organization=${encodeURIComponent(settingFilterFormat.organization)}&log_by=${settingFilterFormat.log_by ? settingFilterFormat.log_by === 'ParkSmart Tag' ? "PARKSMART-TAG" : settingFilterFormat.log_by === "FASTag" ? "NON-ANPR" : settingFilterFormat.log_by : ""}&gates=${settingFilterFormat.gates ? JSON.stringify(settingFilterFormat.gates) : ""}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            signal: abortLogsSummaryRequest.current.signal,
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) {
                    setSummary({ loading: false, data: responseJson.data, count: Object.keys(responseJson.data.vehicleTypes).length });
                } else {
                    setSummary({ ...summary, loading: false });
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                if (e.name === "AbortError") console.log(e);
                else {
                    setSummary({ ...summary, loading: false });
                    notify('Error Fetching Summary', 'warning')
                }
            });
    }
    useEffect(() => {
        getParkingSummary(false)
    }, [startDateTime, endDateTime, settingFilterFormat, currentParking]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const queryParams = queryString.parse(props.location.search);
        if (queryParams.parking)
            setCurrentParking(JSON.parse(queryParams.parking));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    useEffect(() => {
        fetch(`${config.HOST_NAME}/crm/v3/getUserParkingsCount`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setParkingCount(json.data)
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                notify('Something went wrong', 'warning');
            });

    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (showLiveFeed) {
            eventTracker(CATEGORY, "LIVE FEED ENABLE")
            socket.on('connnection', () => {
                console.log('connected to server');
            })

            if (typeof currentParking.id !== "undefined") {
                socket.on(`${currentParking.id}_RFID_LOG`, ({ inserted_log_id, vehicle_number, action }) => {
                    refresh()
                    getParkingSummary(true)
                    setHighLightRecordIds((prev) => {
                        return { ...prev, [inserted_log_id]: inserted_log_id }
                    })
                    setTimeout(() => {
                        setHighLightRecordIds((prev) => {
                            const records = { ...prev };
                            delete records[inserted_log_id];
                            return records
                        })
                    }, 5000);
                    setVisibleSnackBar({ value: true, vehicle_number: vehicle_number, action: action })
                })
            }
            if (parkingCount && parkingCount.count === 1 && parkingCount.parking_id) {
                socket.on(`${parkingCount.parking_id}_RFID_LOG`, ({ inserted_log_id, vehicle_number, action }) => {
                    refresh()
                    getParkingSummary(true)
                    setHighLightRecordIds((prev) => {
                        return { ...prev, [inserted_log_id]: inserted_log_id }
                    })
                    setTimeout(() => {
                        setHighLightRecordIds((prev) => {
                            const records = { ...prev };
                            delete records[inserted_log_id];
                            return records
                        })
                    }, 5000);
                    setVisibleSnackBar({ value: true, vehicle_number: vehicle_number, action: action })
                })
            }

            socket.on('message', (message) => {
                console.log(message);
            })

            socket.on('disconnect', () => {
                console.log('Socket disconnecting');
            })
        }

    }, [showLiveFeed])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // Add more types based on the filters
        let values = {}
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Organization") {
                    values = { ...values, organization: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Vehicle Type") {
                    values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
                if (filterListValue[val].filterType === "Action") {
                    values = { ...values, action: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Log By") {
                    values = { ...values, log_by: filterListValue[val].value ? filterListValue[val].value === "ParkSmart Tag"  ? "PARKSMART-TAG" : filterListValue[val].value === "FASTag" ? "NON-ANPR" : filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Gates") {
                    values = { ...values, gates: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Other") {
                    if (filterListValue[val].value === 'Live Feed') {
                        setShowLiveFeed(true)
                        refresh()
                    } else {
                        setShowLiveFeed(false)
                        socket.close()
                    }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        if(showRfidColumn) RFID_COLUMNS["RFID"] = true
        const displayColumnsKeys = Object.keys(displayColumns);
        const summaryColumnsKeys = Object.keys(RFID_COLUMNS);
        let isOutdated = false;
        for (let i in displayColumnsKeys) {
            if (displayColumnsKeys[i] !== summaryColumnsKeys[i])
                isOutdated = true;
        }
        if (!isOutdated) {
            for (let i in summaryColumnsKeys) {
                if (displayColumnsKeys[i] !== summaryColumnsKeys[i])
                    isOutdated = true;
            }
        }
        if (isOutdated) {
            const temp = { ...RFID_COLUMNS };
            for (let column in RFID_COLUMNS) {
                if (displayColumns[column] === false)
                    temp[column] = false;
                else if (displayColumns[column] === true)
                    temp[column] = true;
            }
            setDisplayColumns(temp);
            localStorage.setItem("rfidLogsColumns", JSON.stringify(temp));
        } else {
            localStorage.setItem("rfidLogsColumns", JSON.stringify(displayColumns));
        }
    }, [displayColumns]); // eslint-disable-line react-hooks/exhaustive-deps

    return (<div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}
            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
            <CustomFilter handleAccessKey={handleAccessKey} filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={RFID_COLUMNS} storageKey="rfidLogsColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
            {!viewOnly && hideMobileNumber && <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} />}
            {/* {(parkingCount?.count === 1 || typeof currentParking?.id !== 'undefined') && <LiveFeed dialogVisible={dialogVisible} setDialogVisible={setDialogVisible} showLiveFeed={showLiveFeed} setShowLiveFeed={setShowLiveFeed} refresh={refresh} />} */}
            {/*<CustomExportButton getCSV={getExcelFile} getPDF={getPDF} reportParams={reportParams} disabled={listDataRef.current && listDataRef.current.total === 0} />*/}
            {!viewOnly && <Button
                className='buttonStyle addBorderRadius'
                variant="contained"
                color="secondary"
                disableElevation
                size="small"
                onClick={reportHandler}
            >
                <GetAppIcon />
            </Button>
            }
        </div>

        <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />
        {showTiles &&
            <div style={{ display: "grid", gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, justifyContent: "space-between", marginTop: 10 }}>
                <PermitSummaryCard
                    title="Vehicle In"
                    data={summary.data}
                    getValue={data => data.enterCount}
                    getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].enterCount > 0).map(type => data.vehicleTypes[type].name)}
                    getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].enterCount > 0).map(type => data.vehicleTypes[type].enterCount)}
                    getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].enterCount > 0).map(type => vehicleSvgs[type])}
                    loading={summary.loading}
                    showDonutChart={true}
                />
                <PermitSummaryCard
                    title="Vehicle Out"
                    data={summary.data}
                    getValue={data => data.exitCount}
                    getDistributedLabels={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].exitCount > 0).map(type => data.vehicleTypes[type].name)}
                    getDistributedValues={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].exitCount > 0).map(type => data.vehicleTypes[type].exitCount)}
                    getDistributedIcons={data => Object.keys(data.vehicleTypes).filter(type => data.vehicleTypes[type].exitCount > 0).map(type => vehicleSvgs[type])}
                    loading={summary.loading}
                    showDonutChart={true}
                />
            </div>
        }


        <List
            {...props}
            style={{ marginTop: 10 }}
            title="RFID Logs"
            bulkActionButtons={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => { listDataRef.current = listData }} />}
        >
            {isSmallDevice ?
                <SimpleList
                    leftIcon={row => displayColumns["Type"] && row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} /> : undefined}
                    primaryText={record => displayColumns["Vehicle Number"] && hideVehicleNumber(record["vehicle_number"])}
                    secondaryText={record => (<div style={{display:"flex", justifyContent:"space-between"}}><div>
                        {displayColumns["Name"] && record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
                        {displayColumns["Mobile"] && hideMobileNumber && privacyFeatureAccess === null ? <FunctionField source="mobile" label="Mobile No." render={record => {
                            return record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{hideMobileMask(record["mobile"])} <PrivacyPasswordAuthentication privacyFeatureAccess={privacyFeatureAccess} setPrivacyFeatureAccess={setPrivacyFeatureAccess} /></div> : ""
                        }} />
                            : <FunctionField source="mobile" label="Mobile No." render={record => record["mobile"] !== null ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}><span style={{ color: "#5a5a5a", marginRight: 5 }}>Mob No: </span>{`${hideMobileMask(record["mobile"])}`}</div> : ""} />
                        }
                        {displayColumns["RFID"] && <div style={{ color: "#444" }}>{record["rfid"]}</div>}
                        {displayColumns["Time"] && record.entry_time && <div><span style={{ color: "#5a5a5a" }}>Entry Time: </span>{record.entry_time}</div>}
                        {displayColumns["Device ID"] && record.entry_device_id ? <div><span style={{ color: "#5a5a5a" }}>Entry Device ID: </span>{record.entry_device_id}</div> : null}
                        {displayColumns["Gate"] && record.entry_gate_id ? <div><span style={{ color: "#5a5a5a" }}>Entry Gate: </span>{record.entry_gate_id}</div> : null}
                        {displayColumns["Gate"] && record.entry_source ? <div><span style={{ color: "#5a5a5a" }}>Entry Source: </span>{record.entry_source && ENTRYEXITMODES[record.entry_source] ? ['FASTag', 'rfid'].includes(record.entry_source)  && record.parksmart_tag === 1 ? 'PSTag' : ENTRYEXITMODES[record.entry_source].label : ENTRYEXITMODES["-"].label}</div> : null}
                        {displayColumns["Time"] && record.exit_time && <div><span style={{ color: "#5a5a5a" }}>Exit Time: </span>{record.exit_time}</div>}
                        {displayColumns["Device ID"] && record.exit_device_id ? <div><span style={{ color: "#5a5a5a" }}>Exit Device ID: </span>{record.exit_device_id}</div> : null}
                        {displayColumns["Gate"] && record.exit_gate_id ? <div><span style={{ color: "#5a5a5a" }}>Exit Gate: </span>{record.exit_gate_id}</div> : null}
                        {displayColumns["Gate"] && record.exit_source ? <div><span style={{ color: "#5a5a5a" }}>Exit Source: </span>{record.exit_source && ENTRYEXITMODES[record.exit_source] ? ['FASTag', 'rfid'].includes(record.exit_source)  && record.parksmart_tag === 1 ? 'PSTag' : ENTRYEXITMODES[record.exit_source].label : ENTRYEXITMODES["-"].label}</div> : null}
                        {displayColumns["Model"] && record.brand && record.model && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{record.brand} {record.model}</div>}
                        {displayColumns["Tag ID"] && record.surface_id && <div><span style={{ color: "#5a5a5a" }}>Tag ID: </span>{record.surface_id}</div>}
                        {/* {displayColumns["Action"] && <div><span style={{ color: "#5a5a5a" }}>Action: </span>{renderActionForMob(record["action"])}</div>} */}
                        {displayColumns["User Type"] && <div><span style={{ color: "#5a5a5a" }}>User Type: </span>{record.user_type}</div>}
                        {displayColumns["Company"] && (showCompany || showCompanyColumn || permissions === "admin") && record.organization && <div><span style={{ color: "#5a5a5a" }}>Company Name: </span>{record.organization}</div>}
                        {displayColumns["Tower"] && (!showCompanyColumn || showFlatDetails || permissions === "admin") && record.society_tower_name && <div><span style={{ color: "#5a5a5a" }}>Tower: </span>{record.society_tower_name}</div>}
                        {displayColumns["Flat Number"] && (!showCompanyColumn || showFlatDetails || permissions === "admin") && record.society_flat_number && <div><span style={{ color: "#5a5a5a" }}>Flat No: </span>{record.society_flat_number}</div>}
                        {displayColumns["Parking Name"] && <div><span style={{ color: "#5a5a5a" }}>Parking: </span>{record["parking_name"]}</div>}

                        {displayColumns['Image'] && <div>
                            <div style={{marginBottom: 5}}>
                                <div style={{ color: "#5a5a5a" }}>Entry Image:</div>
                                <FunctionField label="Image" render={(record) => record && record.entry_image_url ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={record.entry_image_url_thumbnail} record={record} getImages={(record) => {
                                    let parkingImage = defaultImg;
                                    if (record.entry_image_url) {
                                        return [record.entry_image_url]
                                    } else {
                                        return [parkingImage]
                                    }
                                }} /> :
                                    <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <BrokenImageOutlinedIcon />
                                    </div>
                                }
                                />
                            </div>

                            <>
                                <div style={{ color: "#5a5a5a" }}>Exit Image:</div>
                                <FunctionField label="Image" render={(record) => record && record.exit_image_url ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={record.exit_image_url_thumbnail} record={record} getImages={(record) => {
                                    let parkingImage = defaultImg;
                                    if (record.exit_image_url) {
                                        return [record.exit_image_url]
                                    } else {
                                        return [parkingImage]
                                    }
                                }} /> :
                                    <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <BrokenImageOutlinedIcon />
                                    </div>
                                }
                                />
                            </>

                        </div>
                        }
                    </div>
                        </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className={sectionLoader ? 'customStyleDataGrid shimmerTable' : 'customStyleDataGrid'}  component={ScrollableTable} rowStyle={postRowStyle}>
                    {displayColumns["Type"] &&
                        <FunctionField
                            source="vehicle_type"
                            label="Type"
                            render={record => record && renderVehicleType(record)}
                            sortable
                        />
                    }
                    {displayColumns["Vehicle Number"] && <FunctionField source="vehicle_number" label="Vehicle No." render={record => record && record["vehicle_number"] !== null ? <span className='fontWeightSemiBold secondaryColor'>{hideVehicleNumber(record["vehicle_number"])}</span> : "-"} />}
                    {displayColumns["Name"] && <FunctionField source="name" label="User Details" render={record => record &&
                        <div>
                            <div className='logsTableDataColor1 fontWeightBold'>{record.name ? hideName(record.name) : "-"}</div>
                            <div className='logsTableDataColor2 fontWeightMedium'>{record.mobile ? hideMobileMask(record.mobile, privacyFeatureAccess) : "-"}</div>
                        </div>
                    }
                    />}
                    {displayColumns["Tag"] && showTagColumn && <FunctionField label="Tag" render={record => record && renderTagImageDataGrid(record)} />}
                    {displayColumns["User Type"] && <FunctionField source="user_type" label="User Type" render={record => <div style={{textTransform:"capitalize"}}>{record.user_type}</div> }/>}
                    {displayColumns["Flat Number"] && (!showCompanyColumn || showFlatDetails || permissions === "admin") && <FunctionField source="tower" label="Flat" render={record => record &&
                        <div>
                            <div className='logsTableDataColor1 fontWeightBold'>{record.society_flat_number ? record.society_flat_number : "-"}</div>
                            <div className='logsTableDataColor2 fontWeightMedium'>{record.society_tower_name ? record.society_tower_name : "-"}</div>
                        </div>
                    }
                    />}
                    {displayColumns["Parking Slots"] && (!showCompanyColumn || showFlatDetails || permissions === "admin") && <FunctionField source="parking_slots" label="Slots" style={{ textTransform: "capitalize" }} render={record => record && record.parking_slots && record.parking_slots.length > 0 ? record.parking_slots.join(", ") : "-"} />}
                    {displayColumns["Time"] && <FunctionField source="entry_time" label="Entry Time" render={record => record && record.entry_time ? timeFormat(record.entry_time) : "-"}/>}
                    {displayColumns["Entry Gate"] && <FunctionField label="Entry Gate" render={(record) => {
                        const entryGate = record && record.entry_gate_id ? record.entry_gate_id : record.entry_device_id ? record.entry_device_id : '-'
                        const logType = record && record.entry_source && ENTRYEXITMODES[record.entry_source] ? ['FASTag', 'rfid'].includes(record.entry_source)  && record.parksmart_tag === 1 ? 'PSTag' : record.entry_source : '-'
                        return (
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column", textAlign:'center'}}>
                                <div>{entryGate}</div>
                                <div className='fontWeightBold' style={{width: 50, fontSize: 10, padding:"1px 0px", borderRadius: 2, ...ENTRYEXITMODES[logType].style}}>{ENTRYEXITMODES[logType].label}</div>
                            </div>
                        )
                    }} />}
                    {displayColumns['Image'] &&
                        <FunctionField label="Entry Image" render={(record) => record && record.entry_image_url ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={record.entry_image_url_thumbnail}  record={record} getImages={(record) => {
                            let parkingImage = defaultImg;
                            if (record.entry_image_url) {
                                return [record.entry_image_url]
                            } else {
                                return [parkingImage]
                            }
                        }} /> :
                            <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <BrokenImageOutlinedIcon />
                            </div>
                        } />
                    }

                    {displayColumns["Time"] && <FunctionField source="exit_time" label="Exit Time" render={record => record && record.exit_time ? timeFormat(record.exit_time) : "-"}/>}
                    {displayColumns["Exit Gate"] && <FunctionField label="Exit Gate" render={(record) => {
                        const exitGate = record && record.exit_gate_id ? record.exit_gate_id : record.exit_device_id ? record.exit_device_id : '-'
                        const logType = record && record.exit_source && ENTRYEXITMODES[record.exit_source] ? ['FASTag', 'rfid'].includes(record.exit_source) && record.parksmart_tag === 1 ? 'PSTag' : record.exit_source  : '-'
                        return (
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column", textAlign:"center"}}>
                                <div>{exitGate}</div>
                                <div className='fontWeightBold' style={{width: 50, fontSize: 10, padding:"1px 0px", borderRadius: 2, ...ENTRYEXITMODES[logType].style}}>{ENTRYEXITMODES[logType].label}</div>
                            </div>
                        )
                    }} />}
                    {displayColumns["RFID"] && <TextField source="rfid" label="RFID" />}
                    {/* {displayColumns["Duration"] && <FunctionField label="Duration" render={record => record && record.duration ? record.duration : '-'} />} */}
                    {displayColumns['Image'] &&
                        <FunctionField label="Exit Image" render={(record) => record && record.exit_image_url ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={record.exit_image_url_thumbnail} record={record} getImages={(record) => {
                            let parkingImage = defaultImg;
                            if (record.exit_image_url) {
                                return [record.exit_image_url]
                            } else {
                                return [parkingImage]
                            }
                        }} /> :
                            <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <BrokenImageOutlinedIcon />
                            </div>
                        } />
                    }
                    {displayColumns["Model"] && <FunctionField source="brand" label="Model" render={record => record && record.brand && record.model ? `${record.brand} ${record.model}` : "Unknown"} />}
                    {/* {displayColumns["Name"] && <FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />} */}
                    {displayColumns["Tag ID"] && <TextField source="surface_id" label="Tag ID" />}
                    {displayColumns["Company"] && (showCompany || showCompanyColumn || permissions === "admin") && <TextField source="organization" label="Company" />}
                    {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}
                    {displayColumns["Device ID"] && <TextField source="device_id" label="Device ID" />}
                    {displayColumns["Recent Document Validity"] && <FunctionField source="pucc_validity" label="Recent Document Validity" render={record => record && renderDocumentExpiry(record)} />}
                    {displayColumns["Other Images"] && (permissions === "admin" || showSurveillanceImages) && <FunctionField
                        label="Other Images"
                        render={(record) => {
                            const BrokenImage = <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <BrokenImageOutlinedIcon />
                            </div>;
                            if (typeof record.other_images === "string" && record.other_images !== "") {
                                try {
                                    const otherImages = JSON.parse(record.other_images);
                                    if (Array.isArray(otherImages) && otherImages.length > 0) {
                                        return <ImageGalleryDialogV2
                                            thumbnail={true}
                                            record={record}
                                            style={{ textAlign: "left" }}
                                            getImages={record => otherImages}
                                            showMultipleThumbnails={true}
                                        />
                                    } else {
                                        return BrokenImage;
                                    }
                                } catch (err) {
                                    return BrokenImage;
                                }
                            } else {
                                return BrokenImage;
                            }
                        }}
                    />}
                    {displayColumns["Raw Image"] && showAnprRawImage && <FunctionField
                        label="Raw Image"
                        render={(record) => record.raw_image_url ?
                            <ImageGalleryDialogV2
                                thumbnail={true}
                                record={record}
                                style={{ textAlign: "left" }}
                                getImages={(record) => {
                                    let parkingImage = defaultImg;
                                    if (record.raw_image_url) {
                                        return [record.raw_image_url]
                                    } else {
                                        return [parkingImage]
                                    }
                                }}
                            />
                            :
                            <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <BrokenImageOutlinedIcon />
                            </div>
                        }
                    />}
                    {displayColumns["Confidence"] && showAnprRawImage && <TextField source='confidence' label="Confidence" />}
                    {displayColumns["Bounding Box"] && showAnprRawImage && <TextField source='bounding_box' label="Bounding Box" />}
                </Datagrid>
            }
        </List>
    </div>);
};

const LiveFeed = ({ dialogVisible, setDialogVisible, showLiveFeed, setShowLiveFeed, refresh }) => {
    const classes = useStyles()

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    return (
        <div>
            {/* <Switch disabled={props.disabled} checked={Boolean(record.enabled)} onChange={openDialog} /> */}
            {/* <IconButton style={{ color: "#18cc69" }} onClick={openDialog} disabled={showLiveFeed}><AutorenewIcon style={{ fontSize: "12px" }} /></IconButton> */}
            <Button
                variant='contained'
                color="secondary"
                disableElevation
                size="small"
                style={{ textTransform: "none", fontWeight: 500, color: showLiveFeed ? "#18cc69" : '#334d6e', fontSize: 14, fontFamily: "Poppins-Regular", padding: "0px 20px", letterSpacing: "0.06em", borderRadius: 10, backgroundColor: "#F5F8FA", height: "44px" }}
                onClick={openDialog}
                title='Live Feed'
            >
                <LiveTvIcon style={{ fontSize: 20 }} />
            </Button>
            <Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
                <DialogContent>
                    {showLiveFeed ?
                        <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Disable</strong> Auto Refresh</p>
                        :
                        <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Enable</strong> Auto Refresh</p>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        No
                    </Button>
                    <Button onClick={() => {
                        if (showLiveFeed) {
                            setShowLiveFeed(false)
                            socket.close()
                        }
                        else {
                            setShowLiveFeed(true)
                            refresh()
                        }
                        closeDialog()
                    }} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
